import { useMemo } from 'react';
import { useAnalytics } from '../useAnalytics.hook';
import {
  LEAD_CLOSE_EVENTS,
  tLeadCloseDragEndedProps,
  tLeadCloseFormAbandonedProps,
  tLeadCloseFormOpenedProps,
  tLeadCloseMenuOpenedProps,
} from './leadCloseAnalytics.constants';

/** LEA-50: the four LeadClose events, each with its typed props. No PII. */
export function useLeadCloseAnalytics() {
  const { trackEvent } = useAnalytics();

  return useMemo(
    () => ({
      trackDragEnded: (props: tLeadCloseDragEndedProps) =>
        trackEvent(LEAD_CLOSE_EVENTS.DRAG_ENDED, props),
      trackMenuOpened: (props: tLeadCloseMenuOpenedProps) =>
        trackEvent(LEAD_CLOSE_EVENTS.MENU_OPENED, props),
      trackFormOpened: (props: tLeadCloseFormOpenedProps) =>
        trackEvent(LEAD_CLOSE_EVENTS.FORM_OPENED, props),
      trackFormAbandoned: (props: tLeadCloseFormAbandonedProps) =>
        trackEvent(LEAD_CLOSE_EVENTS.FORM_ABANDONED, props),
    }),
    [trackEvent],
  );
}
